import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=601b8f22&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=601b8f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b8f22",
  null
  
)

export default component.exports